module.exports = __webpack_public_path__ + "static/Shipment-img-2f394dcae67f3f79e984a0138d6b187f.png";